import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";
import ImageOpenAnswer from "../../../Components/imageOpenAnswer";

class Answer extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      elementHeight: null,
      elementWidth: null,
      isDragging: false,
      top: 50
    };

    this.callbackRef = this.callbackRef.bind(this);
    this.onImgLoad = this.onImgLoad.bind(this);
    this.changeContainerHeight = this.changeContainerHeight.bind(this);
    this.getOffsetLeft = this.getOffsetLeft.bind(this);
  }

  componentDidMount() {
  }

  callbackRef(element) {
    if (element) {
      this.changeContainerHeight(element.clientHeight);
      if(this.state.elementHeight === null){
        this.setState({
          elementHeight: element.clientHeight,
          elementWidth: element.clientWidth,
        })
      }
    }
  }

  onImgLoad({target:img}) {
    this.changeContainerHeight(img.offsetHeight);
    this.setState({
      elementHeight: img.clientHeight,
      elementWidth: img.clientWidth,
    })
  }

  changeContainerHeight(height) {
    const totalHeight = height + (this.props.question.stackedAnswers ? 50 : 30);

    if (totalHeight > this.props.highestAnswerHeight) {
      this.props.setHighestAnswerHeight(totalHeight)
    }
  }

  getOffsetLeft(){
    const {isActive, answer, question, details} = this.props;

    if(!isActive){
      return null;
    }

    const detail = details.find(detail => detail.answer === answer.id);

    let left = 0;
    if(detail){
      left = Number(((detail.value1 - (question.valueMin * Math.pow(10, question.decimals))) / (question.valueMax * Math.pow(10, question.decimals) - question.valueMin * Math.pow(10, question.decimals))) * 100).toFixed(2);
    }

    return left + '%';
  }

  render() {
    const {answer, question, isActive, isHidden, detail, details} = this.props;
    const {elementHeight, elementWidth, isDragging, top} = this.state;

    const left = this.getOffsetLeft();

    let style = {
      // top: 'calc(' + top + '% - ' + ((elementHeight / 2).toFixed(0) || 0) + 'px)',
      left: 'calc(' + left + ' - ' + ((elementWidth / 2).toFixed(0) || 0) + 'px)',
      zIndex: 1,
      marginBottom: "0 !important"
    };
    if(isActive && elementWidth){
      style.minWidth = elementWidth + 'px';
    }
    if(isDragging){
      style.opacity = 0.3;
    }

    return <React.Fragment
    ><div
        ref={this.callbackRef} data-a={answer.id}
        onTouchMove={e => this.props.setDragging(e.targetTouches[0])}
        onDrag={this.props.setDragging}
        style={style}
        id={isActive ? "a-" + answer.id : ""}
        className={classnames({
      "answer cafetery-wrap d-inline-block p-0": true,
      "mr-3": !isActive && !question.stackedAnswers,
      "active": isActive,
      'stackElement': question.stackedAnswers,
      'position-absolute': !!left,
      'd-none': isHidden,
      'sortable-ghost': isDragging
    })}>
      <div className={"d-flex"} style={{alignItems: "center"}}>
        <ImageOpenAnswer
            answer={answer}
            detail={detail}
            checked={isActive}
            checkboxType={''}
            answersImage={question.answersImage}
            showInput={false}
            showContent={true}
            onOpenChange={e => this.props.onAnswerOpenChange(e.target.value)}
            answerOpenAlwaysShow={false}
        />
      </div>
      {isActive && answer.isOpen && <ImageOpenAnswer
          answer={answer}
          detail={detail}
          checked={isActive}
          checkboxType={''}
          answersImage={false}
          showInput={true}
          showContent={false}
          onOpenChange={e => this.props.onAnswerOpenChange(e.target.value)}
          answerOpenAlwaysShow={false}
      />}
    </div>
    </React.Fragment>
  }
}

Answer.defaultProps = {
  isHidden: false,
};

Answer.propTypes = {
  isHidden: PropTypes.bool,
  question: PropTypes.shape({
    answersImage: PropTypes.bool.isRequired,
    stackedAnswers: PropTypes.bool.isRequired,
  }).isRequired,
  answer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
  }),
  details: PropTypes.array.isRequired,
  isActive: PropTypes.bool.isRequired,
  setHighestAnswerHeight: PropTypes.func.isRequired,
  highestAnswerHeight: PropTypes.number.isRequired,
  setDragging: PropTypes.func.isRequired,
};

export default Answer;